export const fetchI18nList = async (baseURL, version, lang) => {
    const response = await fetch(`${baseURL}/data/v${version}/i18n/${lang}.json`);
    return response.json();
};
